export default __webpack_public_path__ + "static/media/TempBrain.8ec47973.png";